import calls from '@/backend/api-calls'

const state = () => ({
  units: [],
  selected: [],
  allSelected: false,
  loading: false,
  pagination: {
    page: 1,
    pages: 1
  },
  filters: {
  }
})

// getters
const getters = {
  ids: state => {
    return state.units.map(d => d.id);
  }
}

// actions
const actions = {
  getUnits: ({commit}, parameters) => {
    commit("setLoading", true);
    return new Promise((resolve, reject) => {
      calls.units.get(parameters)
        .then(resp => {
          commit("setUnits", resp.data);
          commit("setLoading", false);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  addUnit: ({commit}, data) => {
    return new Promise((resolve, reject) => {
      calls.units.post(data)
        .then(resp => {
          commit("insertUnit", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Unit successfully added'
          }, { root: true });
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  updateUnit: ({commit}, { unitId, data }) => {
    return new Promise((resolve, reject) => {
      calls.unit.put(unitId, data)
        .then(resp => {
          commit("insertUpdatedUnit", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Unit successfully updated'
          }, { root: true });
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  deleteUnit: ({commit}, unitId) => {
    return new Promise((resolve, reject) => {
      calls.unit.delete(unitId)
        .then(resp => {
          commit("removeUnit", unitId);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Unit successfully deleted'
          }, { root: true });
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  toggleAllSelected: ({commit, getters}, value) => {
    if (value) {
      commit("selectAll", getters.ids);
    } else {
      commit("deselectAll");
    }
  }
}

// mutations
const mutations = {
  setLoading(state, status) {
    state.loading = status;
  },
  setUnits (state, data) {
    state.units = data.results;
    state.pagination = data.pagination;
  },
  insertUnit (state, data) {
    state.units.push(data);
  },
  insertUpdatedUnit (state, data) {
    state.units.forEach((unit, i) => {
      if (unit.id == data.id) {
        state.units.splice(i, 1, data);
      }
    })
  },
  removeUnit (state, id) {
    state.units.forEach((unit, i) => {
      if (unit.id == id) {
        state.units.splice(i, 1);
        let ind = state.selected.indexOf(id);
        if (ind != -1) {
          state.selected.splice(ind);
        }
      }
    })
  },
  changePage(state, page) {
    state.pagination.page = page;
  },
  selectAll(state, ids) {
    state.allSelected = true;
    ids.forEach(id => {
      if (state.selected.indexOf(id) == -1) {
        state.selected.push(id);
      }
    })
  },
  deselectAll(state) {
    state.allSelected = false;
    state.selected.splice(0, state.selected.length)
  },
  toggleSelected(state, id) {
    const index = state.selected.indexOf(id);

    if (index == -1) {
      state.selected.push(id);
    } else {
      state.selected.splice(index, 1);
      if (state.selected.length == 0) {
        state.allSelected = false;
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}